module.exports = __webpack_public_path__ + "static/media/icon-file-xls.33956235.svg";